module.exports = __webpack_public_path__ + "img/logotipo-boutsex_WHITE.583ef9de.png";